import { request } from '../request'
// 获取模板列表
export interface GetAttachmentTemplateList {
  name?: string
}
export const getAttachmentTemplateList = (data: GetAttachmentTemplateList) =>
  request('/portal/verify/emailGateway/template/attachment/getAttachmentTemplateList', {
    params: {
      ...data,
    },
  })

// 创建模板
export interface CreateTemplate {
  name: string
  resource_id_list?: string[]
}
export const createTemplate = (data: CreateTemplate) =>
  request('/portal/verify/emailGateway/template/attachment/createAttachmentTemplate', {
    method: 'post',
    data,
  })
// 修改模板名称
export interface UpdateTemplateName {
  name: string
  id: string
}
export const updateTemplateName = (data: UpdateTemplateName) =>
  request('/portal/verify/emailGateway/template/attachment/updateAttachmentTemplateName', {
    method: 'PUT',
    data,
  })
// 删除模板
export interface DeleteTemplate {
  id: string
}
export const deleteTemplate = (data: DeleteTemplate) =>
  request('/portal/verify/emailGateway/template/attachment/deleteAttachmentTemplate', {
    method: 'DELETE',
    data,
  })
//  批量删除模板
export interface BatchDeleteTemplate {
  id_list: string[]
}
export const batchDeleteTemplate = (data: BatchDeleteTemplate) =>
  request('/portal/verify/emailGateway/template/attachment/batchDeleteAttachmentTemplate', {
    method: 'DELETE',
    data,
  })

// 获取模板详情
export interface TemplateDetail {
  id: string
}
export const templateDetail = (data: TemplateDetail) =>
  request('/portal/verify/emailGateway/template/attachment/getAttachmentTemplateDetail', {
    params: {
      ...data,
    },
  })

// 资源池 获取附件资源列表
export interface TemplateResourceList {
  template_id?: string
  keyword?: string
  start_time?: string
  end_time?: string
  risk_level?: string
  attack_type?: string
  attachment_type?: string
  page: number
  limit: number
  tag_ids?: string[]
}
export const templateResourceList = (data: TemplateResourceList) =>
  request('/portal/verify/emailGateway/resource/attachment/getAttachmentList', {
    params: {
      ...data,
    },
  })
// 资源池 批量删除子模板
export interface BatchDeleteResource {
  id_list: string[]
}
export const batchDeleteResource = (data: BatchDeleteResource) =>
  request('/portal/verify/emailGateway/resource/attachment/batchDeleteAttachment', {
    method: 'DELETE',
    data,
  })
// 资源池 删除附件资源
export interface DeleteResource {
  id: string
}
export const deleteResource = (data: DeleteResource) =>
  request('/portal/verify/emailGateway/resource/attachment/deleteAttachment', {
    method: 'DELETE',
    data,
  })
// 资源池 获取附件资源模板详情
export interface GetResourceDetail {
  id: string
}
export const getResourceDetail = (data: GetResourceDetail) =>
  request('/portal/verify/emailGateway/resource/attachment/getAttachmentDetail', {
    params: data,
  })

// 资源池  新增附件资源
export const addTemplateResource = data =>
  request('/portal/verify/emailGateway/resource/attachment/createAttachment', {
    method: 'post',
    timeout: 0,
    headers: {
      'Content-type': 'multipart/form-data',
    },
    data,
  })

//资源池 更新附件资源
export interface UpdateResource {
  id: string
  name: string
  risk_level: number
  attack_type: number
  attachment_type: number
  os: number
  path: string
  describe: string
  solution: string
  tactic_list: object[]
}
export const updateResource = (data: UpdateResource) =>
  request('/portal/verify/emailGateway/resource/attachment/updateAttachment', {
    method: 'PUT',
    data,
  })

//  批量绑定附件
export interface BatchBindAttachment {
  template_id: string
  resource_id_list: string[]
}
export const batchBindAttachment = (data: BatchBindAttachment) =>
  request('/portal/verify/emailGateway/bind/attachment/batchBindAttachment', {
    method: 'POST',
    data,
  })
//  解绑附件
export interface UnbindAttachment {
  template_id: string
  resource_id: string
}
export const unbindAttachment = (data: UnbindAttachment) =>
  request('/portal/verify/emailGateway/bind/attachment/unbindAttachment', {
    method: 'delete',
    data,
  })
//  批量解绑附件
export interface BatchUnbindAttachment {
  template_id: string
  resource_id_list: string[]
}
export const batchUnbindAttachment = (data: BatchUnbindAttachment) =>
  request('/portal/verify/emailGateway/bind/attachment/batchUnbindAttachment', {
    method: 'delete',
    data,
  })
//  修改附件模板启用状态
export interface UpdateAttachmentTemplateStatus {
  id: string
  is_enable: number
}
export const updateAttachmentTemplateStatus = (data: UpdateAttachmentTemplateStatus) =>
  request('/portal/verify/emailGateway/template/attachment/updateAttachmentTemplateStatus', {
    method: 'put',
    data,
  })
//  已绑定列表
export interface GetBoundAttachmentList {
  template_id?: string
  keyword?: string
  start_time?: string
  end_time?: string
  risk_level: string
  attack_type: string
  attachment_type: string
  os: string
  page: number
  limit: number
}
export const getBoundAttachmentList = (data: GetBoundAttachmentList) =>
  request('/portal/verify/emailGateway/bind/attachment/getBoundAttachmentList', {
    params: data,
  })
//  未绑定列表
export interface GetUnboundAttachmentList {
  template_id?: string
  page: number
  limit: number
  keyword?: string
  start_time?: string
  end_time?: string
  risk_level?: string
  attack_type?: string
  attachment_type?: string
  tag_ids?: string[]
}
export const getUnboundAttachmentList = (data: GetUnboundAttachmentList) =>
  request('/portal/verify/emailGateway/bind/attachment/getUnboundAttachmentList', {
    params: data,
  })

// 任务复测
export interface TestTask {
  result_id: string
}
export const testTask = (data: TestTask) =>
  request('/portal/verify/emailGateway/taskReExec', {
    method: 'POST',
    data,
  })

// 附件树结构标签列表
export const getAttachTagTreeOptions = data =>
  request(`/portal/verify/emailGateway/attachment_tags`, {
    params: {
      ...data,
    },
  })

// 全量附件树结构标签列表
export const getSourceAttachTagTreeOptions = data =>
  request(`portal/verify/emailGateway/all/attachment_tags`, {
    params: {
      ...data,
    },
  })
